import { AlertTriangle, X } from 'lucide-react';
import Button from './Button';

interface ConfirmationDialogProps {
    isOpen: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmVariant?: 'primary' | 'danger' | 'success' | 'secondary' | 'ghost';
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
}

export default function ConfirmationDialog({
    isOpen,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmVariant = 'danger',
    onConfirm,
    onCancel,
    loading = false
}: ConfirmationDialogProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600/50 overflow-y-auto h-full w-full z-50 px-4 py-6 sm:py-20">
            <div className="relative mx-auto p-0 border w-full max-w-md shadow-lg rounded-md bg-white">
                {/* Header */}
                <div className="flex items-center justify-between gap-3 p-4 border-b border-gray-200">
                    <div className="flex min-w-0 items-center gap-3">
                        <AlertTriangle className="shrink-0 text-red-500" size={20} />
                        <h3 className="min-w-0 break-words text-lg font-medium text-gray-900">{title}</h3>
                    </div>
                    <Button
                        onClick={onCancel}
                        variant="ghost"
                        size="sm"
                        icon={<X size={20} />}
                        disabled={loading}
                    />
                </div>

                {/* Content */}
                <div className="p-4">
                    <p className="break-words text-gray-700">{message}</p>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-200">
                    <Button
                        onClick={onCancel}
                        variant="ghost"
                        disabled={loading}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        variant={confirmVariant}
                        loading={loading}
                        disabled={loading}
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </div>
    );
} 